(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-login"]) return;
  try {
    
  // Show login form by default. If user click Forgot your password? link it hides Login and show Reset Password form. Use native JS to avoid jQuery dependency.
  var loginForm = document.querySelector('.login__container');
  var resetForm = document.querySelector('.reset__container');
  var recoverLink = document.querySelector('a[href="#recover"]');
  var loginLink = document.querySelector('a[href="#login"]');
  var recoverInput = document.getElementById('RecoverEmail');

  if (window.location.hash === '#recover') {
    loginForm.style.display = 'none';
    resetForm.style.display = 'flex';
    recoverInput.focus();
  }

  recoverLink.addEventListener('click', function (e) {
    e.preventDefault();
    loginForm.style.display = 'none';
    resetForm.style.display = 'flex';
    recoverInput.focus();
  });

  loginLink.addEventListener('click', function (e) {
    e.preventDefault();
    loginForm.style.display = 'flex';
    resetForm.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  var directButton = document.getElementById('direct');
  var professionalButton = document.getElementById('professional');
  var directForm = document.querySelector('.register__customers');
  var professionalForm = document.querySelector('.register__professionals');

  var cancelButtons = document.querySelectorAll('a[href="#cancel"]');

  for (var i = 0; i < cancelButtons.length; i++) {
    cancelButtons[i].addEventListener('click', function(e) {
      e.preventDefault();
      directForm.classList.remove('active');
      professionalForm.classList.remove('active');
    });
  }

  directButton.addEventListener('click', function() {
    directForm.classList.add('active');
    professionalForm.classList.remove('active');
  });

  professionalButton.addEventListener('click', function() {
    directForm.classList.remove('active');
    professionalForm.classList.add('active');
  });

  const customerFormError = document.querySelector('.register__customer--errors');
  const professionalFormError = document.querySelector('.register__professional--errors');
  const errorsContainer = document.getElementById('errors');

  if (customerFormError) {
    errorsContainer.innerHTML = customerFormError.innerHTML;
  }

  if (professionalFormError) {
    errorsContainer.innerHTML = professionalFormError.innerHTML;
  }

  } catch(e) { console.error(e); }
})();
      })();
